import React, { useEffect } from 'react';

import { Button, makeStyles, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    transition: 'all 0.35s ease !important',
    '&:hover': {
      opacity: '0.85 !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      lineHeight: 1.2,
    },
  },
}));

export const NavatticButtonFeaturePopUp = ({
  dataNavatticTitle = '',
  dataNavatticOpen = '',
  ctaText = 'Try A Demo',
  accentColor,
  qbLink,
  iosLink,
}) => {
  const classes = useStyles();
  useEffect(() => {
    if (typeof window === 'undefined' || !window.NavatticEmbed) return;

    const button = document.getElementById('demo');
    if (!button) return;

    const navatticUrl = button.getAttribute('data-navattic-open');
    const navatticTitle = button.getAttribute('data-navattic-title');

    if (!navatticUrl || !navatticTitle) {
      console.warn('Missing data-navattic-* attributes');
      return;
    }

    const config = { title: navatticTitle };
    window.NavatticEmbed.initPopup(navatticUrl, config);

    const handleClick = () => {
      window.NavatticEmbed.openPopup(navatticUrl);
    };

    button.addEventListener('click', handleClick);

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.tagName === 'IFRAME' &&
            node.src.includes('navattic')
          ) {
            console.log('✅ Navattic popup appeared:', node);
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      button.removeEventListener('click', handleClick);
    };
  }, []);

  const lg = useMediaQuery('(max-width: 1280px)');
  const xs = useMediaQuery('(max-width: 481px)');

  return (
    <Button
      size='large'
      variant='contained'
      id='demo'
      data-navattic-title={dataNavatticTitle}
      data-navattic-open={dataNavatticOpen}
      className={classes.button}
      style={{
        background: accentColor,
        color: 'white',
        marginLeft: '1rem',
        marginTop: lg && qbLink ? '2rem' : '1rem',
        padding:
          lg && (!iosLink || !qbLink)
            ? '12px 32px'
            : xs && (!iosLink || !qbLink)
            ? '8px 24px'
            : '16px 32px',
      }}
    >
      {ctaText}
    </Button>
  );
};
